import { dehydrate, QueryClient, useQuery, UseQueryOptions } from 'react-query'
import { ApiClient } from 'services/ApiClient'
import { Api } from 'types/Api'
import { ProductVariantDetail } from 'models/Product'
import { OrderType } from 'models/Order'

export namespace FetchProductVariantDetail {
  export type Response = ProductVariantDetail
  export type Error = Api.Error
  export type Options = UseQueryOptions<Response, Error>
}

const createKey = (slug: string) => ['product-variant', slug]

const queryFetcher = (slug: string) => () => {
  return ApiClient.post<FetchProductVariantDetail.Response>(
    `/v1/product-variants/${slug}/preview`,
    {
      data: { orderType: OrderType.PRODUCTS_SUBSCRIPTION },
    }
  )
}

export const useFetchProductVariantDetail = (
  slug: string,
  options?: FetchProductVariantDetail.Options
) => {
  return useQuery<FetchProductVariantDetail.Response, FetchProductVariantDetail.Error>(
    createKey(slug),
    queryFetcher(slug),
    options
  )
}

export const prefetchProductVariantDetail = async (
  slug: string,
  options?: FetchProductVariantDetail.Options
) => {
  const queryClient = new QueryClient()

  await queryClient.prefetchQuery<
    FetchProductVariantDetail.Response,
    FetchProductVariantDetail.Error
  >(createKey(slug), queryFetcher(slug), options)

  return {
    dehydratedState: dehydrate(queryClient),
    data: queryClient.getQueryData(['product-variant', slug]) as FetchProductVariantDetail.Response,
  }
}